module.exports = __webpack_public_path__ + "media/images/color_admin_v3/user-6-dac2741c9cb8ae56071f2f4799a67dfa.jpg";